import { FC } from 'react';
import { useTranslation } from '../../../utils/useTranslation';
import { FormControlLabel, LabelPlacement } from '../../input/FormControlLabel';
import { Radio } from '../../input/Radio';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { GPTImage } from './styles';
import { CollectionChooseNameFormProps } from './types';

export const CollectionChooseNameForm: FC<CollectionChooseNameFormProps> = ({
    values: { suggests, currentSuggest, suggestsLoading },
    handlers: { onChooseSuggest },
    hideTitle,
}) => {
    const t = useTranslation();
    const text = t(
        'На основе постов, которые вы добавили, наш искусственный интеллект придумал варианты, как ее назвать',
    );
    const loadingText = t('YandexGPT придумывает название для вашей коллекции');
    const title = t('Выберите название коллекции');

    if (!suggestsLoading && !suggests.length) {
        return null;
    }

    return (
        <Flex width="100%" direction="column">
            {!hideTitle && (
                <Typography variant="title3" weight="bold" py={2}>
                    {title}
                </Typography>
            )}
            {suggestsLoading ? (
                <Box margin="auto" height="144px">
                    <Box margin="32px auto 16px" width="fit-content">
                        <GPTImage />
                    </Box>
                    <Typography variant="body" width="245px" textAlign={'center'}>
                        {loadingText}
                    </Typography>
                </Box>
            ) : (
                <>
                    <Typography pb={2} variant="body">
                        {text}
                    </Typography>
                    <Box width="100%">
                        {suggests.map((suggest) => (
                            <FormControlLabel
                                key={suggest}
                                height="56px"
                                label={t(suggest)}
                                labelPlacement={LabelPlacement.LEFT}
                                labelWidth="100%"
                                control={
                                    <Radio
                                        onChange={() => {
                                            onChooseSuggest(suggest);
                                        }}
                                        value={suggest}
                                        checked={currentSuggest === suggest}
                                    />
                                }
                            />
                        ))}
                    </Box>
                </>
            )}
        </Flex>
    );
};
